export const COMPANY_MAPPING: any = {
  icpladda: "icpl",
  icpfertilizer: "icpf",
  icpinter: "icpi",
  iconkaset: "ick",
};

export const COMPANY_FULLNAME_MAPPING: any = {
  icpl: "ICP Ladda Co., Ltd.",
  icpf: "ICP Fertilizer Co., Ltd.",
  icpi: "ICP International Co., Ltd.",
  iconkaset: "Icon Kaset Co., Ltd.",
};
